import type { DocumentRow } from "@/lib/api";

export type DocumentIngestStage = "processing" | "indexing" | "ready" | "index_failed" | "error";

type DocumentIngestSource = Pick<DocumentRow, "status" | "project_id" | "ingest_stage" | "index_status">;

export function inferDocumentIngestStage(doc: DocumentIngestSource): DocumentIngestStage {
  if (doc.ingest_stage === "processing" || doc.ingest_stage === "indexing" || doc.ingest_stage === "ready" || doc.ingest_stage === "index_failed" || doc.ingest_stage === "error") {
    return doc.ingest_stage;
  }
  if (doc.status === "error") {
    return "error";
  }
  if (doc.status === "pending" || doc.status === "processing") {
    return "processing";
  }
  if (doc.project_id == null) {
    return "ready";
  }

  if (doc.index_status === "indexed") {
    return "ready";
  }
  if (doc.index_status === "failed") {
    return "index_failed";
  }
  return "indexing";
}

export function hasNonTerminalDocumentIngestStage(documents: readonly DocumentRow[] | undefined): boolean {
  return (documents ?? []).some((doc) => {
    const stage = inferDocumentIngestStage(doc);
    return stage === "processing" || stage === "indexing";
  });
}

export function pollingIntervalForDocuments(documents: readonly DocumentRow[] | undefined): 4000 | false {
  return hasNonTerminalDocumentIngestStage(documents) ? 4000 : false;
}
